import axios, { AxiosResponse } from 'axios'
import { ExameDtoCadastro, ExameView, PageResponseExameList } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const EXAMES_URL = `${API_URL}/exames`

/**
 * Busca todos os exames
 * @param query string
 * @returns PageResponseExameList
 */
export const getExames = (query: string): Promise<PageResponseExameList> => {
  return axios
    .get(`${EXAMES_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseExameList>) => resp.data)
}

/**
 * Busca um exame
 * @param exameId Identificador do exame
 * @returns ExameView
 */
export const getExameById = (exameId: number): Promise<ExameView> => {
  return axios.get(`${EXAMES_URL}/${exameId}`).then((resp: AxiosResponse<ExameView>) => resp.data)
}

/**
 * Cadastra um exame
 * @param exame ExameDtoCadastro
 * @returns ExameView
 */
export const createExame = (exame: ExameDtoCadastro): Promise<ExameView> => {
  return axios.post(EXAMES_URL, exame).then((resp: AxiosResponse<ExameView>) => resp.data)
}

/**
 * Altera o cadastro de um exame
 * @param exameId Identificador do exame
 * @param exame ExameDtoCadastro
 * @returns ExameView
 */
export const updateExame = (exameId: number, exame: ExameDtoCadastro): Promise<ExameView> => {
  return axios
    .put(`${EXAMES_URL}/${exameId}`, exame)
    .then((resp: AxiosResponse<ExameView>) => resp.data)
}

/**
 * Remove o cadastro de um exame
 * @param exameId Identificador do exame
 * @returns void
 */
export const deleteExame = (exameId: number): Promise<void> => {
  return axios.delete(`${EXAMES_URL}/${exameId}`)
}
